// HOOKS
import useReturnFormComponents from "../../../../hooks/other/useReturnFormComponents";
import { useState, useContext } from "react";
// CONTEXTS
import { VendorsContext } from "../../../../contexts/vendors.context";
import DefaultButton from "../../../buttons/default.button";
import ORDERED_PART_STATUSES from "../../../../constants/parts/orderedPartStatuses.part.constant";
import PAYMENT_METHODS from "../../../../constants/parts/paymentMethods.part.constant";
import WARRANTY_TYPES from "../../../../constants/parts/warrantyTypes.part.constant";

const DEFAULT_FORM_FIELDS = {
  requested_date: "",
  ticket_number: "",
  link: "",
  description: "",
  quantity: "",
  customer: "",
  po_number: "",
  vendor_part_number: "",
  warranty_type: "",
  status: "Part Requested",
  ordered_date: "",
  vendor: "",
  price: "",
  shipping_price: "",
  total_price: "",
  payment_method: "Credit Card",
  eta: "",
  tracking: "",
  received_date: "",
  notes: "",
};

const OpenPartForm = () => {
  const { vendors } = useContext(VendorsContext);
  const { getFormComponents } = useReturnFormComponents();
  const [formFields, setFormFields] = useState(DEFAULT_FORM_FIELDS);
  const handleSave = () => {};
  const [isLoading, setIsLoading] = useState(false);
  const {
    requested_date,
    link,
    description,
    quantity,
    po_number,
    vendor_part_number,
    warranty_type,
    status,
    ordered_date,
    vendor,
    price,
    shipping_price,
    total_price,
    payment_method,
    eta,
    tracking,
    received_date,
    notes,
  } = formFields;
  const handleChange = () => {};

  const FORM_FIELDS = [
    {
      type: "date",
      props: {
        label: "Requested Date",
        value: requested_date,
        name: "requested_date",
        onChange: handleChange,
        className: "w-48",
      },
    },
    {
      type: "selection",
      props: {
        label: "Status",
        value: status,
        name: "status",
        options: ORDERED_PART_STATUSES,
        onChange: handleChange,
        classNames: { container: "w-48" },
      },
    },
    {
      type: "text",
      props: {
        label: "Link",
        value: link,
        name: "link",
        onChange: handleChange,
        className: "w-96",
      },
    },
    {
      type: "text",
      props: {
        label: "Description",
        value: description,
        name: "description",
        onChange: handleChange,
      },
    },
    {
      type: "text",
      props: {
        label: "PO Number",
        value: po_number,
        name: "po_number",
        onChange: handleChange,
        className: "w-48",
      },
    },
    {
      type: "text",
      props: {
        label: "Vendor Part Number",
        value: vendor_part_number,
        name: "vendor_part_number",
        onChange: handleChange,
        className: "w-48",
      },
    },
    {
      type: "selection",
      props: {
        label: "Vendor",
        value: vendor,
        name: "vendor",
        onChange: handleChange,
        options: vendors.map((v) => ({ value: v._id, label: v.name })),
        classNames: { container: "w-48" },
      },
    },
    {
      type: "text",
      props: {
        label: "Tracking",
        value: tracking,
        name: "tracking",
        onChange: handleChange,
        className: "w-96",
      },
    },
    {
      type: "selection",
      props: {
        label: "Warranty Type",
        value: warranty_type,
        name: "warranty_type",
        onChange: handleChange,
        options: WARRANTY_TYPES,
        classNames: { container: "w-48" },
      },
    },
    {
      type: "date",
      props: {
        label: "Ordered Date",
        value: ordered_date,
        name: "ordered_date",
        onChange: handleChange,
        className: "w-48",
      },
    },
    {
      type: "number",
      props: {
        label: "Quantity",
        value: quantity,
        name: "quantity",
        onChange: handleChange,
        className: "w-48",
      },
    },
    {
      type: "number",
      props: {
        label: "Price",
        value: price,
        name: "price",
        onChange: handleChange,
        className: "w-48",
      },
    },
    {
      type: "number",
      props: {
        label: "Shipping Price",
        value: shipping_price,
        name: "shipping_price",
        onChange: handleChange,
        className: "w-48",
      },
    },
    {
      type: "number",
      props: {
        label: "Total Price",
        value: total_price,
        name: "total_price",
        onChange: handleChange,
        className: "w-48",
        readOnly: true,
      },
    },
    {
      type: "selection",
      props: {
        label: "Payment Method",
        value: payment_method,
        name: "payment_method",
        options: PAYMENT_METHODS,
        onChange: handleChange,
        classNames: { container: "w-48" },
      },
    },
    {
      type: "date",
      props: {
        label: "ETA",
        value: eta,
        name: "eta",
        onChange: handleChange,
        className: "w-48",
      },
    },
    {
      type: "date",
      props: {
        label: "Received Date",
        value: received_date,
        name: "received_date",
        onChange: handleChange,
        className: "w-48",
      },
    },
    {
      type: "text",
      props: {
        label: "Notes",
        value: notes,
        name: "notes",
        onChange: handleChange,
        className: "w-96",
      },
    },
  ];

  return (
    <form className="w-[90%] border-animate rounded-2xl shadow-lg  flex flex-col items-center gap-4 p-8 bg-gray-200">
      <h1 className="font-ubuntuBold">Create Ordered Part</h1>
      <div className="flex justify-end w-full px-4 py-2">
        <DefaultButton handleClick={handleSave} loading={isLoading}>
          Save
        </DefaultButton>
      </div>
      <div className="flex flex-wrap gap-4 justify-evenly">
        {getFormComponents({ fields: FORM_FIELDS })}
      </div>
    </form>
  );
};

export default OpenPartForm;
